// Games
export const SET_GAMES = 'SET_GAMES';
// App
export const FILL_STORE = 'FILL_STORE';